import { getApi, postApi, putApi } from "../apiCall";

export const getSelfListings = (user, curr) => {
  if (user !== "consumer" && user !== "generator") return;
  let url = `${
    process.env.REACT_APP_API_URL
  }/bsbp/capacity/${user}/list?currentPage=${curr || 0}&size=${1000}`;
  return getApi(url);
};
export const getSelfListingById = (user, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/${user}/get/${id}/withModifiedStatus`;
  return getApi(url);
};

export const sideBarGeneratorsList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/getGenerators`;
  return getApi(url);
};
export const sideBarConsumerList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/getConsumers`;
  return getApi(url);
};

export const sideBarList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/sideBar`;
  return getApi(url);
};

export const getSelfCounterPartyListings = (user, payload, curr) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/match/${
    user === "consumer" ? "generator" : "consumer"
  }/${
    user === "consumer" ? "againstConsumer" : "againstGenerator"
  }?currentPage=${curr || 0}&size=${1000}`;
  return postApi(url, payload);
};

export const getAllBids = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/list?currentPage=0&size=100&capacityId=${id}`;
  return getApi(url);
};

export const withdrawTerms = (payload, status = false) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/terms/withdraw?isBeforeAcceptance=${status}`;
  return putApi(url, payload);
};
export const withdrawBid = ({ capacityConsumerId, capacityGeneratorId }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/withdraw`;
  return putApi(url, { capacityConsumerId, capacityGeneratorId });
};

export const getInterestedListing = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/list/interested-listings?currentPage=0&size=100&capacityId=${id}`;
  return getApi(url);
};

export const uploadFile = (
  type,
  formData,
  connectionId,
  listingId,
  comment,
) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/upload/${type}/BSB/${connectionId}?listingId=${listingId}`;
  if (comment) {
    url += `&comment=${comment}`;
  }
  return postApi(url, formData, { isFileUpload: true });
};

export const uploadConsent = (formData, connectionId, listingId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/upload/consent/BSB/${connectionId}`;
  return postApi(url, formData, { isFileUpload: true });
};

export const uploadLDC = (formData, connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/upload/ldc/BSB/${connectionId}`;
  return postApi(url, formData, { isFileUpload: true });
};

export const uploadLoiFile = (formData, connectionId, listingId) =>
  uploadFile("loi", formData, connectionId, listingId);

export const uploadLoaFile = (formData, connectionId, listingId) =>
  uploadFile("loa", formData, connectionId, listingId);

export const uploadFaFile = (formData, connectionId, listingId) =>
  uploadFile("agreement", formData, connectionId, listingId);

export const uploadOtherFile = (formData, connectionId, listingId, comment) =>
  uploadFile("random", formData, connectionId, listingId, comment);

export const getDocumentHistory = (connectionId, documentType) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/document/BSB?documentType=${documentType}&connectionId=${connectionId}`;
  return getApi(url, {
    responseType: "blob",
  });
};

export const acceptRequest = (id, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/approvereject/${id}`;
  return putApi(url, payload);
};

export const rejectAgreement = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/connection/rejectAgreement/${connectionId}`;
  return putApi(url);
};

export const getViewDocumentHistory = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/document/BSB?connectionId=${connectionId}`;
  return getApi(url);
};

export const approveDocuments = (payload) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/connection/acceptAgreement`;
  return postApi(url, payload);
};

export const rejectDocuments = (contractId) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/connection/rejectAgreement/${contractId}`;
  return putApi(url);
};
export const submitDocuments = (contractId) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/connection/submit-docs`;
  return putApi(url, { id: contractId });
};

export const getDocumentsDetails = (id) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/document/get/${id}`;
  return getApi(url);
};

// Ledger

export const getLedgerData = (curr, capId) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/approved/match/list?capacityId=${capId}&currentPage=0&size=10`;
  return getApi(url);
};

export const getConnectionDetails = (curr, capId, isTermsAccepted = false) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/get/${capId}`;

  if (isTermsAccepted !== null) {
    url += `?isTermsAccepted=${isTermsAccepted}`;
  }

  return getApi(url);
};

export const getMainScreenConnectionDetails = (capId) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/get/${capId}?listingView=true`;
  return getApi(url);
};

export const getConnectionHistory = (capId, role) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/history?capacityId=${capId}&capacityType=${role}`;
  return getApi(url);
};

export const getArchive = ({ role, status }) => {
  let url = `${
    process.env.REACT_APP_API_URL
  }/bsbp/capacity/${role}/listing/archive?status=${status.toLocaleUpperCase()}&currentPage=0&size=100`;
  return getApi(url);
};

export const getSearchListing = (user, curr, isIntraState, stateLabel) => {
  let url = `${
    process.env.REACT_APP_API_URL
  }/bsbp/capacity/${user}/search?currentPage=${
    curr || 0
  }&size=${100}&stateLabel=${stateLabel}&isIntraState=${isIntraState}`;
  return getApi(url);
};

export const closeListing = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/contract/internal/mark-listings-expired`;
  return putApi(url, payload);
};

export const getDamData = async () => {
  const url = "https://api-gdacc.gna.energy/insights/dam_area_price";

  try {
    // 1. Make the GET request (fetch defaults to GET)
    const response = await fetch(url);

    // 2. Check if the request was successful (status code 200-299)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // 3. Parse and return the JSON data
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch DAM Area Price:", error);
    return null; // Return null or re-throw the error depending on your needs
  }
};
